import { Platform, StyleSheet } from 'react-native';
import { tokens } from '../crop-circle/tokens';
import { Colors } from '../../themes/colors';

export const preferencesStyles = StyleSheet.create({
  contentContainer: {
    paddingTop: tokens.spacing.lg,
    gap: tokens.spacing['2xl'],
    marginBottom: tokens.spacing.lg,
    ...Platform.select({
      web: {
        paddingTop: 0,
      },
    }),
  },
  heading: {
    ...tokens.typography.body.mediumEmphasised,
    color: Colors.role.textStrong,
    marginBottom: tokens.spacing.md,
  },
  // Section title shared by the Crop Circle notification screens, matching the
  // activity filter page (filter/filterContent.tsx `sectionTitle`) so all the
  // settings/filter section headers read consistently.
  sectionTitle: {
    ...tokens.typography.label.largeEmphasised,
    fontWeight: tokens.typography.label.largeEmphasised.fontWeight,
    color: Colors.role.textPrimary,
    marginBottom: tokens.spacing.md,
    letterSpacing: 0.5,
    textTransform: 'uppercase' as const,
  },
  contentFieldFormCropCircle: {
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: Colors.role.canvas,
    borderRadius: tokens.borderRadius.xl,
    flexShrink: 1,
    ...Platform.select({
      web: {
        borderRadius: tokens.borderRadius.lg,
      },
    }),
  },
});
